import {BaseClient} from 'common/report/queries/utils/base-client';
import {assertUnreachable} from 'common/util/typescript';
import {ProfileQueryEndpoint, ProfileQueryParameters} from 'common/report/util/profile/types';

import {queryApiUrl} from '../utils';

class ProfileClient extends BaseClient {
  public buildEndpoint({endpoint}: {endpoint: ProfileQueryEndpoint}): string {
    switch (endpoint) {
      case ProfileQueryEndpoint.Aliases:
      case ProfileQueryEndpoint.Messages:
        return queryApiUrl(`engage/${endpoint}`);
      case ProfileQueryEndpoint.Engage:
        return queryApiUrl(`engage/`);
      default:
        return assertUnreachable(endpoint);
    }
  }

  public buildRequestBody(params: ProfileQueryParameters): string {
    const {dataGroupID, projectId, workspaceId, dateRange, distinctID, distinctIDs, limit} = params;
    return JSON.stringify({
      project_id: projectId,
      ...(dateRange ? {date_range: dateRange} : {}),
      ...(dataGroupID ? {data_group_id: dataGroupID} : {}),
      ...(workspaceId ? {workspace_id: workspaceId} : {}),
      ...(distinctID ? {distinct_id: distinctID} : {}),
      // Must stringify this array now to prevent the 'query-string' package from changing it to "distinct_ids=X" as query-api is expecting an array
      ...(distinctIDs ? {distinct_ids: distinctIDs} : {}),
      ...(limit ? {limit} : {}),
      ...(params.includeEvents ? {include_events: params.includeEvents} : {}),
      ...(params.excludeEvents ? {exclude_events: params.excludeEvents} : {}),
    });

    return null;
  }

  public processResponse(response): Obj {
    return response;
  }

  public async fetchProfileEndpoint<ResultsT>(
    params: ProfileQueryParameters,
    endpoint: ProfileQueryEndpoint,
    clearCache = false,
  ): Promise<ResultsT> {
    const cacheParams = {...params, endpoint};
    const cached = !!this.getCachedResponse(cacheParams);
    let results = {};
    await this.query(cacheParams, {clearCache})
      .then((response) => {
        results = {
          error: null,
          results: response,
          cached,
        };
      })
      .catch((error) => {
        results = {cached, error, results: null};
      });
    return results as ResultsT;
  }
}

export const profileClient = new ProfileClient();
